import { Router } from '@angular/router';
import { RelatorioGerencialRcService } from '@services/relatorio-gerencial-rc.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormService } from 'src/app/services/base-form.service';
import { take } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { FilenameParser } from '@utils/FilenameParser';
import { FileDownloadService } from '@services/file-download.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-relatorio-gerencial-rc',
    templateUrl: './relatorio-gerencial-rc.component.html',
    styleUrls: ['./relatorio-gerencial-rc.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, SelectComponent, NgClass, FormsModule, NgxPaginationModule, FooterComponent, AsyncPipe, CnpjPipe, UsuarioPermissaoPipe]
})
export class RelatorioGerencialRcComponent extends BaseFormService implements OnInit {

  public loadingGenerico: boolean = false;

  public checkedUsersId = [];
  public checkedUsersIdAll: any;
  public selectAllPed: any;
  public selectAll: boolean;

  public resources: any = [];
  public anos: any = [];
  public valorAno: any = '2020';
  public siglaFormatoRelatorio: any = 'H';
  public formatos: any = [];

  public empresa: any = localStorage.idEmpresaLogada;
  public currentPage = 1;

  public totalItemsExiba: any;
  public totalItems = this.resources.length;
  public itemsPerPage = 5;

  public erro: boolean = false;
  public falhaPesquisa: boolean = false;
  public mensagemErro;
  public mensagemErroSubtitulo: any = 'Erro ao listar relatório.'

  public allAnosHasError : boolean = false;

  constructor(
    private readonly relatorioGerencialRcService: RelatorioGerencialRcService,
    private readonly router : Router) { super(); }

  ngOnInit(): void {
    this.getAllAnos();
    this.getAllFormatos();
    this.getAllEmpresas();
  }

  onTableAddressClick(user) {
    let index = this.checkedUsersId.findIndex(x => x == user);
    if (index < 0) {
      this.checkedUsersId.push(user);
    }
    else {
      this.checkedUsersId.splice(index, 1);
    }

    this.checkedUsersIdAll = this.checkedUsersId.length;

    this.selectAllPed = this.checkedUsersId.length == this.totalItemsExiba;

  }

  selectAllUserId(event: any) {

    if (this.checkedUsersId.length == this.resources.length || !event.target.checked) {
      this.checkedUsersId = [];

    } else {
      this.checkedUsersId = [];

      this.resources.forEach(element => {
        this.checkedUsersId.push(element.idEmpresa);
      });

    }

    this.selectAllPed = this.checkedUsersId.length == this.totalItemsExiba;
  }

  isChecked(idEmpresa) {
    let index = this.checkedUsersId.findIndex(x => x == idEmpresa);

    return (index >= 0);

  }

  getAllEmpresas() {

    this.loadingGenerico = true;
    this.relatorioGerencialRcService.getAllEmpresas(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.erro = false;
        this.loadingGenerico = false;
        this.resources = success.response;
        this.totalItemsExiba = success.response.length;
      },
      error: () => {
        this.erro = true;
        this.loadingGenerico = false;
      }
    });

  }

  getAllAnos() {

    this.relatorioGerencialRcService.getAllAnos(this.empresa).pipe(take(1))
    .subscribe({
      next: (success: any) => {
        if (success.response.length == 0) {
          this.allAnosHasError = true;
          this.falhaPesquisa = true;
          this.mensagemErro = 'Não há informações suficientes para extração do relatório.';
          this.mensagemErroSubtitulo = 'Gerar relatório';
          this.totalItemsExiba = 0;
          this.totalItems = 0;
        }
        this.anos = success.response.map(ano => {
          return { ano };
        });
        if (this.anos?.length > 0) {
          this.valorAno = this.anos[0].ano;
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  getAllFormatos() {

    this.relatorioGerencialRcService.getAllFormatos().pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.formatos = success.response;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  getRelatorio() {

    this.mensagemErro = 'Erro ao extrair o relatório.';

    let pathParamsArray = this.getPathParamsArray();
    let pathParams = this.getParamsUrl(pathParamsArray);
    let idsEmpresas = this.getIdsEmpresas();

    this.loadingGenerico = true;
    if (this.siglaFormatoRelatorio == 'H') {

      this.relatorioGerencialRcService.postListaHtml(pathParams, idsEmpresas).pipe(take(1))
      .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
          this.loadingGenerico = false;
          FileDownloadService.openContentInNewWindow(body);
        },
        error: (error) => {
          this.loadingGenerico = false;
          this.falhaPesquisa = true;
          if (error.error.constructor.name === `String`) {
            const { mensagem } = JSON.parse(error.error);
            this.mensagemErro = mensagem;
          }
        }
      });
    }
    else {
      this.relatorioGerencialRcService.postListaFormatos(pathParams, idsEmpresas).pipe(take(1))
      .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
          this.loadingGenerico = false;
          const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'),
            'Arquivo.csv',
          );
          FileDownloadService.download([body], filename);
        },
        error: (error) => {
          this.loadingGenerico = false;
          this.falhaPesquisa = true;
          if (error.error.constructor.name === `Blob`) {
            FileDownloadService.parseJsonFromBlobStream(error.error).then(({ mensagem }) => {
              this.mensagemErro = mensagem;
            }).catch(() => console.error(error));
          }
        }
      });
    }
  }

  fecharAlertErro() {
    this.falhaPesquisa = false;
    (this.allAnosHasError) && this.router.navigate(['/home']);
  }



  getPathParamsArray() {

    let arr = [];

    if (this.anos != '') {

      arr.push({ name: 'ano', comparator: '=', value: this.valorAno });
    }

    if (this.siglaFormatoRelatorio != 'H') {

      arr.push({ name: 'siglaFormatoRelatorio', comparator: '=', value: this.siglaFormatoRelatorio });
    }


    return arr;

  }

  getIdsEmpresas() {
    const idsEmpresas = [];

  if (this.checkedUsersId?.length > 0) {
      for (const id of this.checkedUsersId) {
        idsEmpresas.push(id);
      }
    }
    return idsEmpresas;
  }

  getPage(page: number) {
    this.currentPage = page;
  }
}
